import * as React from 'react'
import { GridPrivateApiCommunity } from '../../../models/api/gridApiCommunity'
import { GridScrollParams } from '../../../models/params/gridScrollParams'
import { GridScrollApi } from '../../../models/api/gridScrollApi'
import { useGridApiMethod } from '../../utils/useGridApiMethod'

export const useGridScroll = (
  apiRef: React.MutableRefObject<GridPrivateApiCommunity>
): void => {
  const colRef = apiRef.current.columnHeadersElementRef!
  const virtualScrollerRef = apiRef.current.virtualScrollerRef!

  const scroll = React.useCallback<GridScrollApi['scroll']>(
    (params: Partial<GridScrollParams>) => {
      if (virtualScrollerRef.current && params.left != null && colRef.current) {
        colRef.current.scrollLeft = params.left
        virtualScrollerRef.current.scrollLeft = params.left
      }
      if (virtualScrollerRef.current && params.top != null) {
        virtualScrollerRef.current.scrollTop = params.top
      }
    },
    [virtualScrollerRef, colRef]
  )

  const getScrollPosition = React.useCallback<
    GridScrollApi['getScrollPosition']
  >(() => {
    if (!virtualScrollerRef?.current) {
      return { top: 0, left: 0 }
    }
    return {
      top: virtualScrollerRef.current.scrollTop,
      left: virtualScrollerRef.current.scrollLeft,
    }
  }, [virtualScrollerRef])

  const scrollApi: GridScrollApi = {
    scroll,
    getScrollPosition,
  }
  useGridApiMethod(apiRef, scrollApi, 'public')
}
